/**
 * Check if token exist or not, if not redirect back to login page
 */
export default function auth({next, router, to, store}) {

  const token = store.getters['auth/token'];
  if (!token) {
    return router.push({ name: 'Login' });
  }
  return next();
}